import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=590307ff&scoped=true&"
import script from "./Card.vue?vue&type=script&lang=js&"
export * from "./Card.vue?vue&type=script&lang=js&"
import style0 from "../Komcard.scss?vue&type=style&index=0&id=590307ff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590307ff",
  null
  
)

export default component.exports